// extracted by mini-css-extract-plugin
module.exports = {"avatarImg":"car-use-form_avatarImg_316Xc","clearButtonContainer":"car-use-form_clearButtonContainer_1SAmO"};